
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiStar as ObiStarElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-star.js';
 
 
 

 
 export const ObiStar = createComponent({
   react: React,
   tagName: 'obi-star',
   elementClass: ObiStarElement,
   events: {
     
   }
  });
 
 